import { render } from "./UploadPlotModal.vue?vue&type=template&id=cbd0a664&scoped=true"
import script from "./UploadPlotModal.vue?vue&type=script&lang=js"
export * from "./UploadPlotModal.vue?vue&type=script&lang=js"

import "./UploadPlotModal.vue?vue&type=style&index=0&id=cbd0a664&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd0a664"]])

export default __exports__